import { Component } from 'react'
import PropTypes from 'prop-types'

class SettingManager extends Component {
    constructor(props) {
        super(props)

        // Expose the commands to dev console
        window.setSettings = this.setSettings
    }

    shouldComponentUpdate() {
        return false
    }

    // Update the settings for the launcher
    // Example input:
    //   {
    //       LauncherEnableHardwareRendering: false,
    //       LauncherEnableHighDpiScaling: false,
    //       LauncherIgnoreCertErrors: false,
    //       LauncherLanguage: 'en',
    //       LauncherRunClientsWithDx9: false,
    //       LauncherRunClientsWithLogging: false,
    //       LauncherShouldDownloadEverything: false,
    //       LauncherShouldMinimizeToTray: false,
    //       LauncherTestServers: ['sisi', 'duality'],
    //       LauncherType: 0,
    //       LauncherUseProxy: true,
    //       ResManThreadCount: 0,
    //   }
    setSettings = (settings) => {
        try {
            // If the EVE servers have not been populated
            // we fill them up with static data
            if (this.props.serverCount === 0) {
                console.info(
                    'No servers received from the launcher application but settings have already been set. Manually populating server list.',
                )
                window.addServers([
                    { name: 'tq', displayName: 'Tranquility' },
                    { name: 'sisi', displayName: 'Singularity' },
                    { name: 'duality', displayName: 'Duality' },
                    { name: 'thunderdome', displayName: 'Thunderdome' },
                ])
            }

            // Store away the incoming settings
            this.props.setSettings(settings)
        } catch (error) {
            console.info(`Encountered error while running setSettings: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

SettingManager.propTypes = {
    serverCount: PropTypes.number,
    setSettings: PropTypes.func,
}

export default SettingManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/SettingManager/component.js